import React from 'react';
import { i18n } from '@lingui/core';
import { t, Trans } from '@lingui/macro';
import { P, RadioGroup } from '@decisiv/ui-components';

import PALETTES from '../../theme/palettes';
import { useTheme } from '../../theme/ThemeProvider';
import {
  ProfileSection,
  SectionHeader,
  SectionTitle,
  PaletteList,
  PaletteRow,
  PaletteSwatch,
} from './style';

export default function AppearanceSection() {
  const { palette, setPalette } = useTheme();

  return (
    <ProfileSection>
      <SectionHeader>
        <SectionTitle id="appearance_title">{t`Appearance`}</SectionTitle>
      </SectionHeader>
      <P color="alaskanHusky" paddingX={2} paddingTop={1}>
        <Trans>
          Night mode palette. The moon button in the top bar switches between
          the light theme and this palette.
        </Trans>
      </P>
      <PaletteList>
        {PALETTES.map(({ id, swatch }) => (
          <PaletteRow key={id} aria-hidden="true">
            <PaletteSwatch>
              {swatch.map((hex) => (
                <i key={hex} style={{ background: hex }} />
              ))}
            </PaletteSwatch>
          </PaletteRow>
        ))}
        <RadioGroup
          name="night_palette"
          role="radiogroup"
          aria-labelledby="appearance_title"
          vertical
          value={palette}
          items={PALETTES.map(({ id, name, description }) => ({
            value: id,
            label: `${i18n._(name)} — ${i18n._(description)}`,
          }))}
          onChange={(event) => setPalette(event.target.value)}
        />
      </PaletteList>
    </ProfileSection>
  );
}
